import { render } from "./ProjectSection.vue?vue&type=template&id=3282a423"
import script from "./ProjectSection.vue?vue&type=script&lang=js"
export * from "./ProjectSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__